import { NgModule } from '@angular/core';
import { ScrolledBarComponent } from './scrolled-bar.component';
import { ScrolledContentDirective } from './scrolled-content.directive';
import { CommonModule } from '@angular/common';
import { ScrollBarService } from './scroll-bar.service';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ScrolledBarComponent,
        ScrolledContentDirective
    ],
    exports: [
        ScrolledBarComponent,
        ScrolledContentDirective
    ],
    providers: [
        ScrollBarService
    ]
})
export class ScrollBarModule { }
